import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'
import { createI18n } from 'vue-i18n'
import CHS from '../locales/langs/zh-CN.json'
import EN from '../locales/langs/en-US.json'
import { PageKey } from '~/constants/page'
import { SAFE_HOST } from '~/utils/constant'
import { COOKIE_KEY } from '~/constants/config'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

export default defineNuxtPlugin(({ vueApp }) => {
  const requestURL = useRequestURL()
  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()
  // 1. 初始化日志 level
  consola.level = 4
  if (
    runtimeConfig.public.env === 'production' &&
    process.env.NODE_ENV === 'production'
  ) {
    consola.level = 0
  }

  // 同步埋点数据到bi所需随机用户id
  if (
    !getCookie(COOKIE_KEY.USER_RANDOM_ID) &&
    !runtimeConfig.public.privatization
  ) {
    setCookie(COOKIE_KEY.USER_RANDOM_ID, uuid())
  }

  // 2. 初始化安全域名检测
  if (
    !runtimeConfig.public.privatization &&
    runtimeConfig.public.env === 'production' &&
    process.env.NODE_ENV === 'production' &&
    !SAFE_HOST.some((item) => item.test(requestURL.host)) &&
    route.name !== PageKey.NOT_FOUND
  ) {
    navigateTo('/not-found')
    return {}
  }

  // 3. 初始化时区信息
  const timezone = useCookie(COOKIE_KEY.TIMEZONE).value || 'Asia/Shanghai'
  dayjs.tz.setDefault(timezone)
  if (import.meta.client) {
    setCookie(COOKIE_KEY.TIMEZONE, dayjs.tz.guess())
  }

  // 4. 初始化 i18n 信息
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: getDefaultLocale(),
    messages: {
      'zh-CN': CHS,
      'en-US': EN,
    },
  })

  vueApp.use(i18n)

  useHead({
    htmlAttrs: {
      lang: getDefaultLocale(),
    },
    script: [
      {
        src: `${runtimeConfig.app.cdnURL}/libs/qrcode.js`,
        defer: true,
      },
      {
        src: `${runtimeConfig.app.cdnURL}/lib-pag/libpag.min.js`,
        defer: true,
      },
    ],
  })

  return {
    provide: {
      t: i18n.global.t,
      dayjs,
    },
  }
})
